<template>
  <ModalClose :modal="modal" asChild>
    <Button variant="destructive" size="grow">
      <TrashThree v-if="withIcon" class="w-5 h-5" />
      <span class="px-0.5 text-lg/normal md:text-base font-semibold">
        {{ label || t("components.buttons.confirm") }}
      </span>
    </Button>
  </ModalClose>
</template>

<script setup>
import { Button } from "@/Shadcn/Components/ui/button";
import { TrashThree } from "@/Icons";
import { useI18n } from "vue-i18n";
import { ModalClose } from "@/Components/Buttons";

defineProps({
  modal: { type: String, required: false },
  label: { type: String, required: false },
  withIcon: { type: Boolean, default: true },
});

const { t } = useI18n();
</script>
